import { useState, useEffect } from 'react';

const SMALL_SCREEN_BREAKPOINT = 640;

/**
 * Tracks the viewport width on resize.
 * Returns:
 *   width         — current window.innerWidth
 *   isSmallScreen — width < 640 (Tailwind `sm`)
 *   logoClass     — legacy helper used by older components
 */
function useScreenSize() {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSmallScreen = width > 0 && width < SMALL_SCREEN_BREAKPOINT;

  return { width, isSmallScreen, logoClass: isSmallScreen ? 'hidden' : '' };
}

export default useScreenSize;
